<div class="row">
  <div class="col-sm-12">
    <app-viewform [objRecordDetails]="objRecordDetails"></app-viewform>
  </div>
</div>